<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-card class="mb-0 auth-card">
        <b-link class="brand-logo">
          <Logo />
          <h2 class="brand-text text-primary ml-1">IMEI Checker</h2>
        </b-link>

        <div class="auth-header">
          <h2 class="mb-0">Magic Link Sign-in</h2>
          <div class="auth-subtitle">Signing you in without a password.</div>
        </div>

        <!-- Loading -->
        <div v-if="loading" class="text-center my-2">
          <b-spinner variant="primary" type="grow" label="Loading" />
          <div class="text-muted small mt-1">Verifying your link…</div>
        </div>

        <!-- States -->
        <template v-else>
          <b-alert v-if="!token" variant="danger" show class="mb-2">
            <div class="alert-body">Missing token in the URL.</div>
          </b-alert>

          <b-alert v-else-if="error" variant="danger" show class="mb-2">
            <div class="alert-body">This magic link is invalid or expired.</div>
          </b-alert>

          <b-alert v-else variant="success" show class="mb-2">
            <div class="alert-body">Signed in. Redirecting…</div>
          </b-alert>

          <b-button
            v-if="!token || error"
            variant="primary"
            block
            @click="$router.push({ name: 'login', query: { magic: '1' } })"
          >
            Back to login
          </b-button>
        </template>

        <b-card-text class="text-center text-muted small mt-2 mb-0">
          This site is protected by reCAPTCHA and the Google
          <b-link
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener"
            >Privacy Policy</b-link
          >
          and
          <b-link
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noopener"
            >Terms of Service</b-link
          >
          apply.
        </b-card-text>
      </b-card>
    </div>
  </div>
</template>

<script>
import Auth from "@/services/auth.service.js";
import { BAlert, BButton, BCard, BCardText, BLink, BSpinner } from "bootstrap-vue";
import Logo from "@core/layouts/components/Logo.vue";

export default {
  components: {
    BAlert,
    BButton,
    BCard,
    BCardText,
    BLink,
    BSpinner,
    Logo,
  },
  data() {
    return {
      loading: true,
      error: null,
      // Read token immediately to avoid "Missing token" flash
      token: this.$route?.query?.token || null,
    };
  },
  created() {
    // No token -> stop and show message (no request)
    if (!this.token) {
      this.loading = false;
      return;
    }
    this.consume();
  },
  methods: {
    async consume() {
      this.loading = true;
      this.error = null;

      try {
        // Expected: GET /auth/magic-link?token=...
        // Backend returns { token: "JWT" } -> storeToken() -> reload
        await Auth.consumeMagicLink(this.token);

        // If reload doesn't happen for any reason:
        this.loading = false;
      } catch (e) {
        this.error =
          e.response?.data?.message ||
          e.response?.data ||
          "Failed to sign in. Please request a new link.";
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/pages/page-auth.scss";

.auth-card {
  border-radius: 0.9rem;
}
.auth-header {
  margin-top: 0.25rem;
}
.auth-subtitle {
  margin-top: 0.25rem;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
}
</style>
